module.exports = __webpack_public_path__ + "media/img/vca/nomh4-f32180d7c40004458768282b17177a07.png";